import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import Modal from './Modal';
import { selectStyles } from './selectTheme';

/* Shared address add/edit dialog — same look in cart page and user dashboard. */
export default function AddressModal({ open, onClose, title, initial, submitLabel, onSubmit, busy }) {
  const [form, setForm] = useState({ province: '', city: '', address: '', postal_code: '', is_default: false });
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    if (open) {
      setForm({
        province: initial?.province || '',
        city: initial?.city || '',
        address: initial?.address || '',
        postal_code: initial?.postal_code || '',
        is_default: !!initial?.is_default,
      });
      axios.get('/regions/provinces').then(r => setProvinces(r.data || [])).catch(() => {});
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!form.province) { setCities([]); return; }
    axios.get('/regions/cities', { params: { province: form.province } }).then(r => setCities(r.data || [])).catch(() => {});
  }, [form.province]);

  const label = { display: 'block', fontSize: '0.76rem', color: 'var(--muted-fg)', marginBottom: 4 };
  const input = { width: '100%', padding: 12, borderRadius: 12, border: '1.5px solid var(--border)', fontFamily: 'inherit', fontSize: '0.9rem', background: 'var(--card)', color: 'var(--fg)', outline: 'none', boxSizing: 'border-box', marginBottom: 10 };

  return (
    <Modal open={open} onClose={onClose} title={title || 'آدرس'}>
      <div>
        <label style={label}>استان</label>
        <div style={{ marginBottom: 10 }}>
          <Select
            styles={selectStyles}
            isRtl isSearchable
            placeholder="جستجو و انتخاب استان..."
            options={provinces.map(p => ({ value: p.name || p, label: p.name || p }))}
            value={form.province ? { value: form.province, label: form.province } : null}
            onChange={o => setForm({ ...form, province: o ? o.value : '', city: '' })}
          />
        </div>
        <label style={label}>شهر</label>
        <div style={{ marginBottom: 10 }}>
          <Select
            styles={selectStyles}
            isRtl isSearchable
            isDisabled={!form.province}
            placeholder={form.province ? 'جستجو و انتخاب شهر...' : 'اول استان را انتخاب کنید'}
            options={cities.map(c => ({ value: c, label: c }))}
            value={form.city ? { value: form.city, label: form.city } : null}
            onChange={o => setForm({ ...form, city: o ? o.value : '' })}
          />
        </div>
        <label style={label}>نشانی کامل</label>
        <textarea value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} placeholder="نشانی کامل" rows={2} style={{ ...input, resize: 'vertical' }} />
        <label style={label}>کدپستی (اختیاری)</label>
        <input value={form.postal_code} onChange={e => setForm({ ...form, postal_code: e.target.value.replace(/[^0-9]/g, '') })} placeholder="کدپستی" style={input} inputMode="numeric" />
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.82rem', fontWeight: 600, marginBottom: 12, cursor: 'pointer', color: 'var(--fg)' }}>
          <input type="checkbox" checked={!!form.is_default} onChange={e => setForm({ ...form, is_default: e.target.checked })} style={{ width: 17, height: 17, accentColor: 'var(--primary)' }} />
          آدرس پیش‌فرض من باشد
        </label>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => onSubmit && onSubmit(form)} disabled={busy} style={{ flex: 1, padding: 13, borderRadius: 12, border: 'none', background: 'var(--primary)', color: 'var(--on-primary)', fontFamily: 'inherit', fontSize: '0.9rem', fontWeight: 800, cursor: 'pointer', opacity: busy ? 0.55 : 1 }}>{submitLabel || 'ذخیره'}</button>
          <button onClick={onClose} style={{ flex: 1, padding: 13, borderRadius: 12, border: '1px solid var(--border)', background: 'var(--card)', color: 'var(--fg)', fontFamily: 'inherit', fontSize: '0.9rem', fontWeight: 700, cursor: 'pointer' }}>انصراف</button>
        </div>
      </div>
    </Modal>
  );
}
